<template>
    <div class="card-body">
        <div class="row">
            <div class="col-md-2">
                <span class="title">Name:</span>
            </div>
            <div class="col-md-10">
                <p class="detail">{{ user.name }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <span class="title">Title:</span>
            </div>
            <div class="col-md-10">
                <p class="detail">{{ user.title }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <span class="title">Email:</span>
            </div>
            <div class="col-md-10">
                <p class="detail">{{ user.email }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <span class="title">Company:</span>
            </div>
            <div class="col-md-10">
                <p class="detail">{{ user.company.name }}</p>
            </div>
        </div>
        <div class="row" v-if="user.linkedin">
            <div class="col-md-2">
                <span class="title">Linkedin:</span>
            </div>
            <div class="col-md-10">
                <p class="detail">{{ user.linkedin }}</p>
            </div>
        </div>
        <div class="row" v-if="user.twitter">
            <div class="col-md-2">
                <span class="title">Twitter:</span>
            </div>
            <div class="col-md-10">
                <p class="detail">{{ user.twitter }}</p>
            </div>
        </div>
        <hr>
        <p>To edit your profile, please contact <a href="mailto:help@csuitecircle.com">help@csuitecircle.com</a>.</p>
    </div>
</template>

<script>
export default {

    props: {
        user: {
            type: Object
        }
    },
}
</script>
